import { Box } from '@factorialco/deprecated-design-system'
import { SectionHeader } from '@factorialco/f0-react/dist/experimental'
import { SaleInvoiceUpsertSidepanelQuery } from 'generated/resources/graphql'

import { useUnsafeMemo } from 'modules/core/hooks/useMemo'
import i18n from 'modules/core/lib/i18n'

import { countryComplianceExtraFieldsConfig } from 'modules/finance/components/Invoices/SaleInvoicesUpsertSidepanel/lib/complianceExtraFields'
import { SaleInvoiceDocument } from 'modules/finance/lib/salesInvoiceUtils'

import LineItems from './_LineItems'
import Summary from './_Summary'

type FinanceFinancialDocumentComplianceExtraFieldsConfig = NonNullable<
  SaleInvoiceUpsertSidepanelQuery['finance']
>['financialDocumentComplianceExtraFieldsConfigs'][number]

interface FinancialDocumentCoreProps {
  locale: string
  saleInvoice: SaleInvoiceDocument
  complianceExtraFieldsConfigs?: FinanceFinancialDocumentComplianceExtraFieldsConfig[]
}

const FinancialDocumentCore = ({
  locale,
  saleInvoice,
  complianceExtraFieldsConfigs = [],
}: FinancialDocumentCoreProps) => {
  const invoiceComplianceExtraFieldsConfig = useUnsafeMemo(() => {
    return countryComplianceExtraFieldsConfig(
      complianceExtraFieldsConfigs,
      saleInvoice.issuerCountryCode || undefined
    )
  }, [complianceExtraFieldsConfigs, saleInvoice.issuerCountryCode])

  return (
    <Box gap="s24" flexDirection="column" paddingBottom="s24">
      <SectionHeader title={i18n.t('finance.sale_invoices.detail.summary')} description={''} />
      <Summary
        saleInvoice={saleInvoice}
        complianceExtraFieldsConfigsByCountry={invoiceComplianceExtraFieldsConfig}
        showInvoiceNumber
      />
      <LineItems
        locale={locale}
        saleInvoice={saleInvoice}
        countryComplianceExtraFieldsConfig={invoiceComplianceExtraFieldsConfig}
      />
    </Box>
  )
}

export default FinancialDocumentCore
